<template>
    <div class="coupon">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="left-tab">
                        <span class="tab-item" :class="{active:showType=='NO'}" @click.stop="showType='NO'">未开始</span>
                        <span class="tab-item" :class="{active:showType=='ING'}" @click.stop="showType='ING'">进行中</span>
                        <span class="tab-item" :class="{active:showType=='EXPIRED'}" @click.stop="showType='EXPIRED'">已过期</span>
                        <span class="tab-item" :class="{active:showType=='STOP'}" @click.stop="showType='STOP'">已作废</span>
                    </div>
                   <div class="searchCon clearfix">
                        <div class="right searchBtn" style="width:130px;">
                            <button type="button" @click="showUpBox"><i class="el-icon-plus"></i>添加优惠券</button>
                        </div>
                    </div>
                </div>
                <div class="HSpace2"></div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:10%;">优惠券名称</th>
                                <th style="width:8%;">优惠券类型</th>
                                <th style="width:18%;">抵用商品名称</th>
                                <th style="width:5%;">已派发</th>
                                <th style="width:5%;">已使用</th>
                                <th style="width:10%;">每天使用数量限制</th>
                                <th style="width:14%;">有效时间</th>
                                <th style="width:10%;">创建时间</th>
                                <th style="width:10%;">操作人</th>
                                <th style="width:10%;">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable fixed-td" style="table-layout:fixed;" :class="{overLengthTable:couponList.length<10}">
                                    <tr v-for="(item,ind) in couponList">
                                        <td style="width:10%;"><span v-text="item.title"></span></td>
                                        <td style="width:8%;"><span>{{couponTypeText[item.type]}}</span></td>
                                        <!-- <td style="width:14%;"><span>{{item.startTime | numberToDate('')}}</span></td> -->
                                        <td style="width:18%;">
                                            <el-tooltip class="item" :key="ind" effect="dark" :content="item.productName" placement="top">
                                                <span class="overflowText">{{item.productName}}</span>
                                            </el-tooltip>
                                        </td>
                                        <td style="width:5%;"><span>{{item.sendCount}}</span></td>
                                        <td style="width:5%;"><span>{{item.useCount}}</span></td>
                                        <td style="width:10%;"><span>{{item.limitCount}}</span></td>
                                        <td style="width:14%;">
                                            <template v-if="item.id">
                                                    <span v-if="item.id && item.startTime && item.endTime && !item.expireDay">{{item.startTime | numberToDate('')}} 至 {{item.endTime | numberToDate('')}}</span>
                                                    <span v-else>{{item.expireDay}}天</span>
                                            </template>
                                        </td>
                                        <td style="width:10%;"><span v-if="item.id">{{item.addTime | numberToDate('')}}</span></td>
                                        <td style="width:10%;">
                                            <template v-if="item.id">
                                                <span>{{item.createName}}</span>
                                            </template>
                                        </td>
                                        <!-- <td style="width:14%;"><span v-text="couponTypeText[item.type]"></span></td> -->
                                        <td style="width:10%;">
                                            <div v-if="item.id" class="btnInline">
                                                <!-- <el-button type="text" title="详情" @click="uploadCoupon(item)">查看详情</el-button> -->
                                                <el-button type="text" title="详情" @click="toDetail(item)">查看详情</el-button>
                                                <el-button type="text"  title="编辑" @click="uploadCoupon(item)"><i class="iconfont icon-bianji"></i></el-button>
                                                <!-- <el-button type="text" title="删除" @click="delCoupon(item.id)"><i class="iconfont icon-icon1460188478041"></i></el-button> -->
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 分页器 -->
                <div class="pager flex flex-align-center">
                    <div class="pagerCon clearfix">
                        <div class="pagerBtnBox right">
                            <div class="pagerBtn">
                                <span class="prev flex flex-align-center flex-pack-center left" :class="{havePage:(curPage>0)}" @click="changePage(false)"><i class="el-icon-arrow-left"></i></span>
                                <span class="curPageNumber flex flex-align-center flex-pack-center left" v-text="''+(curPage+1)"></span>
                                <span class="next flex flex-align-center flex-pack-center left" :class="{havePage:((curPage+1)<totalPage)}" @click="changePage(true)"><i class="el-icon-arrow-right"></i></span>
                            </div>
                        </div>
                        <div class="curPage flex flex-align-center right" v-text="'第 '+(curPage+1)+' / '+totalPage+' 页'"></div>
                        <div class="totalPage flex flex-align-center right" v-text="'共'+totalElements+'条'"></div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="'优惠券'"
            class="close-top"
            :visible.sync="addCouponBtn"
            size="tiny">
            <div>
                <div class="msg clearfix" @click="goodCheckArr=[]">
                    <div class="left msgItem clearfix">
                        <span class="left itemName">优惠券类型</span>
                        <el-radio class="radio left itemRadio" v-model="couponType" label="GET_ITEM_FREE">商品抵用券</el-radio>
                        <el-radio class="radio left itemRadio" v-model="couponType" label="REDUCE">代金券</el-radio>
                        <!-- <el-radio v-model="couponType" label="2">现金抵用券</el-radio> -->
                    </div>
                    <div class="couponConBox left clearfix">
                        <div class="left msgItem clearfix" v-if="couponType!='REDUCE'">
                            <span class="left itemName"><i>*</i>是否可分享</span>
                            <el-radio class="radio left itemRadio" v-model="shareable" label="ON">是</el-radio>
                            <el-radio class="radio left itemRadio" v-model="shareable" label="OFF">否</el-radio>
                        </div>
                        <div class="left msgItem clearfix" style="height:50px;line-height:16px;">
                            <span class="left itemName"><i>*</i>开启每天使用数量限制</span>
                            <el-radio class="radio left itemRadio" v-model="newCoupon.openLimitEnabled" :label="true">是</el-radio>
                            <el-radio class="radio left itemRadio" v-model="newCoupon.openLimitEnabled" :label="false">否</el-radio>
                        </div>
                        <!--  -->
                        <div class="left msgItem clearfix" style="height:50px;line-height:16px;" v-if="newCoupon.openLimitEnabled">
                            <span class="left itemName"><i>*</i>限制数量</span>
                            <input type="number" class="left itemInput" min="0" v-model="newCoupon.limitCount" placeholder="请输入数量" >
                            <span class="notice">使用数量限制</span>
                        </div>
                        <!--  -->
                        <div class="left msgItem clearfix">
                            <span class="left itemName"><i>*</i>{{couponType=="GET_ITEM_FREE"?"抵用券名称":"代金券名称"}}</span>
                            <input type="text" class="left itemInput" v-model="newCoupon.title" placeholder="请输入名称" >
                            <span class="notice">如：奶茶{{couponType=="GET_ITEM_FREE"?"抵用券":"代金券"}}</span>
                        </div>
                        <!--  -->
                        <div class="left msgItem clearfix" v-if="couponType=='REDUCE'">
                            <span class="left itemName"><i>*</i>代金券金额</span>
                            <input type="text" class="left itemInput" v-model="newCoupon.couponAmount" placeholder="请输入金额" >
                        </div>
                        <!--  -->
                        <div class="left msgItem clearfix">
                            <span class="left itemName"><i>*</i>商品名称</span>
                            <!-- <input type="text" class="left itemInput" v-model="keyWords" placeholder="请输入商品名称" > -->
                            <el-button type="primary" size="mini" @click.stop="showCouponGoods = true">添加</el-button>
                            <span class="notice">注：抵用商品(可多选)</span>
                            <!-- <ul class="goodCheckList" :style="{display:(goodCheckArr[0]?'block':'none')}" @click.stop="">
                                <div class="leftIcon" :style="{top:(curGoodIdx*40+'px')}">
                                    <div class="iconInner"></div>
                                </div>
                                <li v-for="item in goodCheckArr" @click="selSearchGood(item)">
                                    <div class="name ellipsis" v-text="item.name" :title="item.name"></div>
                                </li>
                            </ul> -->
                        </div>
                        <div class="left msgItem clearfix" style="min-height:32px;height:auto;" v-if="seledGoods && seledGoods.length">
                            <span class="left itemName">已选商品</span>
                            <div class="seled-mat-list">
                                <el-tag
                                closable
                                @close="cancelCouponGoods(tag)"
                                v-for="tag in seledGoods"
                                :key="tag.name"
                                >
                                {{tag.name}}
                                </el-tag>
                            </div>
                        </div>
                        <div class="left msgItem clearfix" v-if="false">
                            <span class="left itemName"><i>*</i>使用时间</span>
                            <!-- <span style="position:relative;">
                                <input type="tel" class="left itemInput" v-model="newCoupon.expireDays" placeholder="请输入过期时间" ><span class="left" style="position:absolute;right:10px;color:red;">天</span>
                            </span>
                            <span class="notice">注：抵用券可使用的天数（由创建时间开始算起）</span> -->
                           <!--  <el-date-picker
                              v-model="timeFromTo"
                              type="daterange"
                              value-format="yyyy/MM/dd"
                              range-separator="至"
                              start-placeholder="开始日期"
                              :picker-options="pickerOptions0"
                              end-placeholder="结束日期">
                            </el-date-picker> -->
                            <el-date-picker
                              v-model="timeFrom"
                              type="date"
                              :editable="false"
                              :picker-options="pickerOptions0"
                              value-format="yyyy/MM/dd"
                              placeholder="选择开始日期">
                            </el-date-picker>
                            <span>至</span>
                            <el-date-picker
                              v-model="timeTo"
                              value-format="yyyy/MM/dd"
                              type="date"
                              :editable="false"
                              :picker-options="pickerOptions0"
                              placeholder="选择到期日期">
                            </el-date-picker>
                        </div>
                        <!--  -->
                        <div class="left msgItem clearfix">
                            <span class="left itemName"><i>*</i>有效天数</span>
                            <input type="number" class="left itemInput" v-model="newCoupon.expireDay" placeholder="请输入有效天数" >天
                            <span class="notice">*以派发时间为起始时间</span>
                        </div>
                        <!--  -->
                        <div class="left msgItem clearfix">
                            <span class="left itemName">优惠说明</span>
                            <input type="text" class="left itemInput" v-model="newCoupon.description" placeholder="请输入优惠说明(选填)" >
                            <span class="notice">注：抵用某个现有商品（如：免费送奶茶）</span>
                        </div>
                        <div class="left clearfix textareaBox msgItem">
                            <span class="left itemName"><i>*</i>使用规则</span>
                            <textarea name="aa" id="" cols="30" rows="4" v-model="newCoupon.notice" class="left itemTextarea" placeholder="请输入使用规则">555</textarea>
                            <span class="notice">注：默认使用规则，仅供参考，请根据实际情况修改。</span>
                        </div>
                        <div class="left img_box clearfix">
                            <span class="left itemName"><i>*</i>{{couponType=="GET_ITEM_FREE"?"抵用券":"代金券"}}图片</span>
                            <div class="left img">
                                <div class="img_item left">
                                    <img v-if="newCoupon.logoURL" :src="newCoupon.logoURL" alt="">
                                </div>
                                <div class="img_up_btn left">
                                    <i class="iconfont icon-xiazai"></i>
                                    <input type="file" accept=".png,.jpg,.jpeg" @change="coverImg" class="pcImgFile" title="选择图片">
                                    <input type="file" accept="image/*" @change="coverImg" class="mobileImgFile">
                                </div>
                                <div class="left flex flex-align-center" style="height:74px;color:#999;">
                                    <span class="notice">注：{{couponType=="GET_ITEM_FREE"?"抵用券":"代金券"}}的展示图，可以为某个商品的图片，也可以为默认图</span>
                                </div>
                                <div class="clear"></div>
                                <div class="uploadImgTip">
                                    支持JPG、JPEG、PNG格式，单张大小不超过<span style="color:red;">200KB</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addCouponBtn=false" class="cancel">取消</button>
                <button type="button" @click="saveCoupon" class="save">保存</button>
            </span>
        </el-dialog>
        <!--  -->
        <el-dialog
            :title="'修改优惠券'"
            class="close-top"
            :visible.sync="editCouponBtn"
            size="tiny">
            <div>
                <div class="msg clearfix" @click="goodCheckArr=[]">
                    <div class="couponConBox left clearfix">
                        <div class="left msgItem clearfix">
                            <span class="left itemName" style="width:120px"><i>*</i>{{couponType=="GET_ITEM_FREE"?"抵用券名称":"代金券名称"}}:</span>
                            <!-- <span class="notice" style="color:#333;">{{newCoupon.title}}</span> -->
                            <b>{{newCoupon.title}}</b>
                        </div>
                        <template v-if="!isShowOld">
                            <div class="left msgItem clearfix">
                                <span class="left itemName" style="width:120px"><i>*</i>商品名称:</span>
                                <!-- <input type="text" class="left itemInput" v-model="keyWords" placeholder="请输入商品名称" > -->
                                <el-button type="primary" size="mini" @click.stop="showCouponGoods = true">添加</el-button>
                                <span class="notice">注：抵用商品(可多选)</span>
                            </div>
                            <div class="left msgItem clearfix" style="min-height:32px;height:auto;" v-if="seledGoods && seledGoods.length">
                                <span class="left itemName">已选商品:</span>
                                <div class="seled-mat-list">
                                    <el-tag
                                    closable
                                    @close="cancelCouponGoods(tag)"
                                    v-for="tag in seledGoods"
                                    :key="tag.name"
                                    >
                                    {{tag.name}}
                                    </el-tag>
                                </div>
                            </div>
                        </template>
                        <template v-if="isShowOld">
                            <div class="left msgItem clearfix">
                                <span class="left itemName" style="width:20%"><i>*</i>到期时间:</span>
                                <el-date-picker
                                v-model="timeTo"
                                value-format="yyyy/MM/dd"
                                type="date"
                                :editable="false"
                                :picker-options="pickerOptions0"
                                placeholder="选择到期日期">
                                </el-date-picker>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="editCouponBtn=false" class="cancel">取消</button>
                <button type="button" @click="editCoupon" class="save">保存</button>
            </span>
        </el-dialog>
        <!--  -->
        <img-crop v-if="showCrop" :oldImg="oldImgBase64" :curCropW="curCropW" :curCropH="curCropH" :curStoreId="curStoreId" @closeImgCrop="showCrop=false" @getCropImgBase="getCropImgBase"></img-crop>
        <selCouponGoods
            v-if="showCouponGoods"
            @selOk="selOk"
            :seledGoods="seledGoods"
            :storeId="curStoreId"
            @closeSelGoods="showCouponGoods=false"
        />
    </div>
</template>

<script type="text/javascript">
    import {url} from '@/router/url.js';
    import imgCrop from '@/components/imgCrop/imgCrop.vue';
    import {API_BASE_URL} from "./../../../urlConfig/index";
    import selCouponGoods from "@/components/selCouponGoods/selGoods";

    export default{
        components: {imgCrop,selCouponGoods},
        props: ['pageSize','curStoreId'],
        data () {
            return {
                isShowOld:false,
                editCouponBtn:false,
                openLimitEnabled:false,
                nowSelProIds:[],
                seledGoods:[],
                showCouponGoods:false,
                showType:"ING",
                dialogVisible: false,
                addCouponBtn:false,//添加规则按钮
                couponList:[
                ],//规则列表
                rulesId:'',//规则id
                couponType:'GET_ITEM_FREE',
                couponTypeText: {
                    'GET_ITEM_FREE': '商品抵用券',
                    "REDUCE":"代金券"
                },
                newCoupon: {
                    id: '', // 新优惠券id
                    title: '', // 名称
                    notice: '', // 使用说明
                    description: '', // 详细说明
                    type: 'GET_ITEM_FREE', // 优惠券类型
                    productId: '', // 商品id
                    productName: '', // 商品名称
                    source: 'STORE', // 优惠券来源
                    storeId: this.curStoreId, // 店铺id
                    shareable: false, // 是否可分享
                    expireDays: 0, // 过期时间
                    logoURL: '', // 优惠券图片
                    openLimitEnabled:false,
                    limitCount:"",
                    expireDay:"",
                },
                shareable: 'OFF', // 是否可分享
                goodCheckArr: [], // 商品检索数组
                keyWords: '', // 商品检索关键字
                goodSearchBtn: true, // 控制商品检索请求
                curGoodIdx: 0, // 商品检索索引

                coverImgMaxSize: 5000*1024, // 图片最大字节数
                oldImgBase64: '', // 原图base64
                showCrop: false, // 控制图片裁剪显示隐藏
                curCropW: 600, // 裁剪宽度
                curCropH: 600, // 裁剪高度
                infoload: false, // loading

                curPage: 0,//当前页，用于切换页码
                totalPage: 1,//总共页
                totalElements: 0,//总共条

                addCouponApiBtn: true, // 控制新增接口

                pickerOptions0: {
                //时间禁用,今天以后的时间禁用。
                    disabledDate(time) {
                        return time.getTime() <= Date.now() - 1000*60*60*24;
                    }
                },
                timeFromTo: ['',''],
                timeFrom:'',
                timeTo:''
            }
        },

        watch:{
            keyWords : function(val){
                if ( this.newCoupon.productName == this.keyWords ) {
                    this.goodCheckArr = [];
                    return;
                }
                this.goodSearch();
            },
            showType(val){
                this.getCouponList();
            },
            addCouponBtn(val){
                if(!val){
                    this.nowSelProIds = [];
                    this.seledGoods = [];
                }
            },
            "newCoupon.limitCount"(val){
                if(val<0){
                    this.newCoupon.limitCount = 0;
                    this.$forceUpdate();
                }
            },
            editCouponBtn(val){
                if(!val){
                    this.nowSelProIds = [];
                    this.seledGoods = [];
                    this.addCouponApiBtn = true;
                }
            }
        },
        methods: {
            cancelCouponGoods(tag){
                console.log(tag);
                let seledGoods = JSON.parse(JSON.stringify(this.seledGoods));
                let index;
                let flag = false;
                if(seledGoods && Array.isArray(seledGoods) && seledGoods.length){
                    seledGoods.forEach((it,ind)=>{
                        if(it.id == tag.id){
                            index = ind;
                            flag = true;
                        }
                    })
                }
                seledGoods.splice(index,1);
                this.seledGoods = seledGoods;
            },
            selOk(data){
                console.log(data);
                this.seledGoods = data.nowSelectGoods;
                this.nowSelProIds = data.proIds;
                this.showCouponGoods = false;
            },
            // 
            toDetail(item){
                this.$router.push({
                    name:"couponProfile",
                    query:{
                        id:item.id,
                        createName:item.createName,
                        couponName:item.title,
                        cteateTime:item.addTime,
                        startTime:item.startTime ? item.startTime : "",
                        endTime:item.endTime ? item.endTime : "",
                        expireDay:item.expireDay?item.expireDay:"",
                        sendCount:item.sendCount,
                        useCount:item.useCount,
                        goodsName:item.productName,
                        status:this.showType=="STOP"?"STOP":"NORMAL",
                        statusType:this.showType
                    }
                })
            },
            showUpBox(item){
                this.timeTo = '';
                this.timeFrom = '';
                this.addCouponBtn = true;
                this.newCoupon = {
                    id: this.$uuid.create(1).hex, // 新优惠券id
                    title: '', // 名称
                    notice: '1、每位会员每单限使用一张，不可叠加使用。 2、本券不可兑换现金且不退不换，不与其它活动同享，使用本券不提供发票。 3、一切解释权归发行方所有', // 使用说明
                    description: '', // 详细说明
                    type: 'GET_ITEM_FREE', // 优惠券类型
                    productId: '', // 商品id
                    productName: '', // 商品名称
                    source: 'STORE', // 优惠券来源
                    storeId: this.curStoreId, // 店铺id
                    shareable: false, // 是否可分享
                    expireDays: 1, // 过期时间
                    openLimitEnabled: false,
                    limitCount: "", 
                    expireDay: "", 
                    logoURL: 'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png', // 优惠券图片
                };
                this.keyWords = '';
                this.shareable = 'OFF';
            },
            // 保存优惠券
            saveCoupon: function () {
                if ( this.shareable == 'ON' ) {
                    this.newCoupon.shareable = true;
                } else {
                    this.newCoupon.shareable = false;
                }

                if ( !this.newCoupon.title ) {
                    this.$message({
                        message: '请输入名称',
                        customClass: 'error'
                    })
                    return;
                }
                if(this.couponType=="REDUCE"){
                    if(!this.newCoupon.couponAmount){
                        this.$message({
                            message: '请输入代金券金额',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(!/^(0|[1-9][0-9]{0,9})(\.[0-9]{1,2})?$/.test(this.newCoupon.couponAmount)){
                        this.$message({
                            message: '代金券金额格式有误',
                            customClass: 'error'
                        })
                        return;
                    }
                }
                if ( !this.newCoupon.notice ) {
                    this.$message({
                        message: '请输入使用说明',
                        customClass: 'error'
                    })
                    return;
                }
                // if ( !this.newCoupon.productId ) {
                //     this.$message({
                //         message: '请选择商品',
                //         customClass: 'error'
                //     })
                //     return;
                // }
                // if(this.newCoupon.couponType!="REDUCE"){
                    if(!this.nowSelProIds || !this.nowSelProIds.length){
                        this.$message({
                            message: '请选择商品',
                            customClass: 'error'
                        })
                        return;
                    }
                // }
                
                // if ( !this.timeFrom ) {
                //     this.$message({
                //         message: '请选择优惠券(代金券)使用开始时间',
                //         customClass: 'error'
                //     })
                //     return;
                // }
                // if ( !this.timeTo ) {
                //     this.$message({
                //         message: '请选择优惠券(代金券)过期时间',
                //         customClass: 'error'
                //     })
                //     return;
                // }
                // if ( new Date(this.timeTo).getTime()< new Date(this.timeFrom).getTime() ) {
                //     this.$message({
                //         message: '开始时间不能大于过期时间',
                //         customClass: 'error'
                //     })
                //     return;
                // }

                if(!this.newCoupon.expireDay){
                    this.$message({
                        message: '有效天数填写有误',
                        customClass: 'error'
                    })
                    return;
                }

                if(!/^\d+$/.test(this.newCoupon.expireDay)){
                    this.$message({
                        message: '有效天数填写有误',
                        customClass: 'error'
                    })
                    return;
                }

                if(this.newCoupon.expireDay<=0){
                    this.$message({
                        message: '有效天数填写有误',
                        customClass: 'error'
                    })
                    return;
                }
                
                if ( this.newCoupon.openLimitEnabled ) {
                    if(!/\d+/.test(this.newCoupon.limitCount)){
                            this.$message({
                            message: '限制数量填写有误',
                            customClass: 'error'
                        })
                        return;
                    }
                    if(this.newCoupon.limitCount<=0){
                        this.$message({
                            message: '限制数量填写有误',
                            customClass: 'error'
                        })
                        return;
                    }
                }

                if ( !this.addCouponApiBtn ) {
                    return;
                }
                this.addCouponApiBtn = false;
                let productId = [],productName = [];
                if(this.seledGoods && Array.isArray(this.seledGoods) && this.seledGoods.length){
                    this.seledGoods.forEach(it=>{
                        productId.push(it.id);
                        productName.push(it.name);
                    })
                }
                console.log(productName)
                let aNewCoupon = {
                    description:this.newCoupon.description,
                    // startDate: new Date(this.timeFrom).Format('yyyy-MM-dd'),
                    // endDate: new Date(this.timeTo).Format('yyyy-MM-dd'),
                    id:this.newCoupon.id,
                    logoURL:this.newCoupon.logoURL,
                    notice:this.newCoupon.notice,
                    productId:productId.join(","),
                    productName:productName.join(","),
                    shareable:this.couponType == "REDUCE" ? false : this.newCoupon.shareable,
                    source:this.newCoupon.source,
                    storeId:this.newCoupon.storeId,
                    title:this.newCoupon.title,
                    // type:this.newCoupon.type,
                    type:this.couponType,
                    couponAmount:this.couponType == "REDUCE" ? this.newCoupon.couponAmount : "",
                    openLimitEnabled:this.newCoupon.openLimitEnabled,
                    limitCount:this.newCoupon.openLimitEnabled ? this.newCoupon.limitCount : "",
                    createName:localStorage.getItem("username"),
                    expireDay:this.newCoupon.expireDay
                };
                if ( !aNewCoupon.logoURL ) {
                    aNewCoupon.logoURL = 'https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png';
                }
                this.$http.post('coupon', aNewCoupon).then((res)=>{
                    this.addCouponApiBtn = true;
                    this.addCouponBtn = false;
                    this.getCouponList();
                }).catch(()=>{
                    this.addCouponApiBtn = true;
                })
            },
            editCoupon(){
                let productId = [],productName = [];
                if(this.seledGoods && Array.isArray(this.seledGoods) && this.seledGoods.length){
                    this.seledGoods.forEach(it=>{
                        productId.push(it.id);
                        productName.push(it.name);
                    })
                }
                if(!productId || !productId.length){
                    this.$message({
                        message: '请选择商品',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !this.addCouponApiBtn ) {
                    return;
                }
                this.addCouponApiBtn = false;
                let params = {
                    id:this.newCoupon.id,
                    storeId:this.curStoreId,
                    productId:productId.join(","),
                    productName:productName.join(","),
                };
                if(this.isShowOld){
                    if(!this.timeTo){
                        this.$message({
                            message: '请选择过期时间',
                            customClass: 'error'
                        })
                        return;
                    }
                    params = Object.assign(params,{
                        endDate:new Date(this.timeTo).Format('yyyy-MM-dd')
                    })
                }
                this.$http.post('coupon',params).then((res)=>{
                    this.addCouponApiBtn = true;
                    this.editCouponBtn = false;
                    this.getCouponList();
                }).catch(()=>{
                    this.addCouponApiBtn = true;
                })
            },
            // 删除优惠券
            delCoupon(couponId){
                this.$confirm('此操作将删除该券, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    //删除商品
                   this.$http.delete('coupon?id='+couponId).then((res)=>{
                        if( res.status ){
                            this.getCouponList();
                        }
                    })
                }).catch(() => {});
            },
            // 修改优惠券
            uploadCoupon: function ( item ) {
                // if ( !item.startTime ) {
                //     this.timeFrom = '';
                //     this.timeTo = '';
                // } else {
                //     this.timeFrom = new Date(item.startTime);
                //     this.timeTo = new Date(item.endTime);
                // }
                this.isShowOld = false;
                this.newCoupon.title = item.title;
                this.newCoupon.id = item.id;
                let seledGoods = [];
                this.editCouponBtn = true;
                if(item.productId && item.productName){
                    let productIds = item.productId.split(",");
                    let productNames = item.productName.split(",");
                    for(let i=0;i<productIds.length;i++){
                        let obj = {
                            id:productIds[i],
                            name:productNames[i],
                            count:1,
                        }
                        seledGoods.push(obj);
                    }
                }
                this.seledGoods = seledGoods;
                if(item.expireDay == 0 && item.endTime){
                    this.timeTo = item.endTime;
                    this.isShowOld = true;
                }
                // this.newCoupon = {
                //     // 
                //     id: item.id, // 新优惠券id
                //     title: item.title, // 名称
                //     notice: item.notice, // 使用说明
                //     description: item.description, // 详细说明
                //     type: item.type, // 优惠券类型
                //     productId: item.productId, // 商品id
                //     productName: item.productName, // 商品名称
                //     source: item.source, // 优惠券来源
                //     storeId: item.storeId, // 店铺id
                //     shareable: item.shareable, // 是否可分享
                //     expireDays: item.expireDays, // 过期时间
                //     logoURL: item.logoURL, // 优惠券图片
                // };
                // if (  this.newCoupon.shareable) {
                //     this.shareable = 'ON' ;
                // } else {
                //     this.shareable = 'OFF' ;
                // }
                // this.keyWords = item.productName;
                // this.addCouponBtn = true;
            },
            //列表翻页
            changePage: function ( boo ) {
                if ( boo ) {
                    if ( (this.curPage + 1) >= this.totalPage ) {
                        return;
                    }
                    this.curPage++;
                } else {
                    if ( this.curPage <= 0 ) {
                        return;
                    }
                    this.curPage--;
                }
                this.getCouponList();
            },
            // 获取优惠券列表
            getCouponList: function () {
                this.$http.get('coupon?storeId='+this.curStoreId+'&page='+this.curPage+'&pageSize='+this.pageSize+'&status='+this.showType).then((res)=>{
                    console.log(res)
                    this.couponList = res.data.dtos;
                    this.totalPage = res.data.totalPages;
                    this.totalElements = res.data.totalElements;
                    if( this.couponList.length < this.pageSize ){
                        for(let i = 0, len = this.pageSize - this.couponList.length; i < len; i++){
                            this.couponList.push({})
                        }
                    }
                }).catch(()=>{

                })
            },
            // 选择检索商品
            selSearchGood: function ( item ) {
                // console.log(item);
                this.newCoupon.productName = item.name;
                this.newCoupon.productId = item.id;
                this.keyWords = item.name;
                this.goodCheckArr = [];
            },
            // 商品检索
            goodSearch: function () {
                let val = this.keyWords;
                if ( !val ) {
                    this.goodCheckArr = [];
                    return;
                }
                if ( !this.goodSearchBtn ) {
                    return;
                }
                this.goodSearchBtn = false;
                this.$http.get('products/search?storeId='+this.curStoreId+'&q='+encodeURI(val)).then((res)=>{
                    this.goodCheckArr = res.data;
                    let btn = true;
                    for (var i = 0, len = this.goodCheckArr.length; i < len; i++) {
                        if ( this.keyWords == this.goodCheckArr[i].name ) {
                            this.newCoupon.productId = this.goodCheckArr[i].id;
                            this.newCoupon.productName = this.goodCheckArr[i].name;
                            btn = false;
                            break;
                        }
                    }
                    if ( btn ) {
                        this.newCoupon.productName = '';
                        this.newCoupon.productId = '';
                    }

                    setTimeout(()=>{
                        let that = this;
                        $('.goodCheckList li').hover( function () {
                            that.curGoodIdx = $(this).index()-1;
                        }, function () {
                            that.curGoodIdx = 0;
                        })
                    },0)
                    this.goodSearchBtn = true;
                }).catch(()=>{
                    this.goodSearchBtn = true;
                })
            },
            coverImg: function ( e ) {
                let reader = new FileReader();
                let that = this;
                let fileObj = e.target.files[0];

                if( e.target.files.length == 0 ) {
                    return false;
                }

                // 判断图片大小
                if( fileObj.size > this.coverImgMaxSize ) {
                    this.errorMsg = '上传图片的大小不能超过5MB';
                    this.openErrorTip = true;
                    this.$message({
                        message: '上传图片的大小不能超过5MB',
                        customClass: 'error'
                    })
                    return false;
                }

                reader.onload = (function (file) {
                    return function (e) {
                        let that2 = this; // 缓存当前this
                        let img = new Image();
                        img.src= this.result;
                        img.onload=function(){
                            let imgBase64 = that2.result; //获得图片的base64的数据


                            // 判断是否是移动端设备
                            let sUserAgent = navigator.userAgent.toLowerCase();
                            let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                            let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                            let bIsMidp = sUserAgent.match(/midp/i) == "midp";
                            let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                            let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                            let bIsAndroid = sUserAgent.match(/android/i) == "android";
                            let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                            let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                                that.mobileUploadImg(imgBase64);
                            } else {
                                that.oldImgBase64 = imgBase64;
                                that.showCrop = true;
                            }
                        };
                        $('.pcImgFile').val('');
                        $('.mobileImgFile').val('');
                    };
                })(e.target.files[0]);
                reader.readAsDataURL(e.target.files[0]);
            },
            // 移动端上传图片
            mobileUploadImg: function (imgBase64) {
                this.infoload = true;
                this.$http.post(API_BASE_URL+'v1/image/json/upload?storeId='+this.curStoreId, {file: imgBase64}).then((res)=>{
                    this.newCoupon.logoURL = res.data.path;
                    this.infoload = false;
                }).catch(()=>{
                    this.infoload = false;
                });
            },
            // 获得裁剪后图片base64
            getCropImgBase: function ( imgUrl )　{
                this.newCoupon.logoURL = imgUrl;
            }
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.couponList.push({})
            }
        },
        activated: function () {
            if(this.$route.query.type){
                this.showType = this.$route.query.type;
            }
           this.getCouponList();
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
    @import "addcoupon";
    .close-top{
        .el-dialog,.el-dialog--tiny{
            top: 7.89% !important;
        }
    }
    .el-tooltip__popper{
        max-width: 300px;
        max-height: 350px;
        overflow: hidden;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// addcoupon.vue?7303cce0